import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addFinancialInfo } from '../api/finances';

export function useAddFinancialInfo({
  onSuccess,
}: {
  onSuccess?: () => void;
} = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addFinancialInfo,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['financial-info'] });
      onSuccess?.();
    },
  });
}
